module.exports = __webpack_public_path__ + "img/ceping83_details.b4924496.png";